import React from "react";
import PropTypes from "prop-types";
import Select, { components } from "react-select";
import makeAnimated from "react-select/animated";

const customStyles = {
  control: (base) => ({
    ...base,
    minHeight: "38px",
    borderRadius: "4px",
    borderColor: "#ccc",
  }),
  multiValue: (base) => ({
    ...base,
    backgroundColor: "#e9ecef",
  }),
  multiValueLabel: (base) => ({
    ...base,
    color: "#495057",
    fontSize: "0.875rem",
  }),
  multiValueRemove: (base) => ({
    ...base,
    color: "#6c757d",
    ":hover": {
      backgroundColor: "#adb5bd",
      color: "white",
    },
  }),
  // Only applies when the caller portals the menu (menuPortalTarget): without it the menu
  // would sit under the page header and any card rendered later.
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
};

const OptionCheckbox = (props) => (
  <components.Option {...props}>
    <input
      type="checkbox"
      checked={props.isSelected}
      onChange={() => null}
      style={{ marginRight: 8 }}
    />
    <label>{props.label}</label>
  </components.Option>
);

const MultiSelectField = ({
  options,
  value,
  onChange,
  placeholder,
  isDisabled,
  styles,
  menuPortalTarget,
  menuPlacement,
  ariaLabel,
}) => (
  <Select
    aria-label={ariaLabel}
    isMulti
    closeMenuOnSelect={false}
    hideSelectedOptions={false}
    components={{ Option: OptionCheckbox, ...makeAnimated() }}
    styles={{ ...customStyles, ...(styles || {}) }}
    options={options}
    value={value}
    onChange={onChange}
    placeholder={placeholder}
    isDisabled={isDisabled}
    menuPortalTarget={menuPortalTarget}
    menuPlacement={menuPlacement}
  />
);

MultiSelectField.propTypes = {
  /** [{ value: any, label: string }] */
  options: PropTypes.array.isRequired,
  /** same shape as options array for selected values */
  value: PropTypes.array.isRequired,
  /** (newValue: Array) => void */
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  isDisabled: PropTypes.bool,
  /** optional react-select styles overrides (merged over defaults) */
  styles: PropTypes.object,
  /**
   * Render the menu into this node (usually document.body). Needed inside any container that
   * creates a stacking context — a transform, e.g. an entrance animation — or the next sibling
   * card paints over the open menu whatever its z-index.
   */
  menuPortalTarget: PropTypes.any,
  /** "bottom" (default) | "top" | "auto" */
  menuPlacement: PropTypes.oneOf(["auto", "bottom", "top"]),
  /** accessible name for the input, so a screen reader or a test finds it by the field's label */
  ariaLabel: PropTypes.string,
};

MultiSelectField.defaultProps = {
  placeholder: "Select...",
  isDisabled: false,
  menuPortalTarget: undefined,
  menuPlacement: "bottom",
};

export default MultiSelectField;
